import * as _ from 'lodash';
import PosActions from '../../../actions/PosActions';

import UserStore from '../../../stores/UserStore';
import PosStore from '../../../stores/PosStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import Price from '../../form/Price.react';

// import Stucky from 'stucky';
import StickyHeader from '../../form/StickyHeader.react';
import { getApiUrl } from '../../../utils/ApiUrls';

class ViewHistory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading             : false,
            type                : 'product',
            productHistory      : false,
            selected            : false,
            transactionHistory  : false,
            filter              : '',

            sortBy              : 'PosDate',
            sortType            : 'desc',
        };

        this.loadProductHistory = this.loadProductHistory.bind(this);
        this.loadTransactionHistory = this.loadTransactionHistory.bind(this);
        this.exportHistory = this.exportHistory.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
    }

    componentDidMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        this.setState({
            productHistory: false,
            transactionHistory: false,
        });
        this.props.page == 'history' && this.loadProductHistory();
        
    }

    componentWillReceiveProps(nextProps) {

        const myPages = ['history', 'product', 'transaction'];
        if(!myPages.includes(this.props.page) && myPages.includes(nextProps.page)) {
            this.loadProductHistory();
        }
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        $('.pos-sidebar').css({'z-index' : 2 });
    }

    componentDidUpdate() {
        $('.pos-sidebar').css({
            'z-index' : this.state.selected ? 1 : 2,
        });
    }

    onPosStoreChange() {
        this.setState({
            productHistory : PosStore.getState().productHistory,
            transactionHistory : PosStore.getState().transactionHistory,
            loading: false,
        });
    }

    loadProductHistory() {
        this.setState({
            productHistory : false,
            loading: true,
        }, () => {
            PosActions.productHistory(this.props.guest.Guest_id);
        });
    }

    loadTransactionHistory() {
        this.setState({
            transactionHistory : false,
            loading: true,
        }, () => {
            PosActions.transactionHistory(this.props.guest.Guest_id);
        });
    }

    exportHistory(event, kind) {
        event.stopPropagation();
        $(`#${kind}-history-export`).submit();
    }

    render() {
        const guest   = this.props.guest;
        const page    = this.props.page;

        if (page !== 'history' && page !== 'product' && page !== 'transaction')
            return null;

        const user     = UserStore.getApiData();
        const location = UserStore.getState().selectedLocation;
        let   bgColor  = '#ffffff';
        const history  = this.state.type === 'product' ? this.state.productHistory : this.state.transactionHistory;

        const filter          = this.state.filter;
        let   filteredList    = [];

        for (let i=0; i<history.length; i++) {
            if (filter.length < 1)
                filteredList.push(history[i]);
            else {
                if (this.state.type === 'product') {
                    if (history[i].ReceiptNo.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].SerialNo.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].ProductDesc.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].ProductSku.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].Instructions.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].OwnerLocation.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].PosDate.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
                        history[i].PrescriptionNumber.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                        filteredList.push(history[i])
                } else {
                    if (history[i].PosId.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                            filteredList.push(history[i])
                }
            }
        }

        const sortBy          = this.state.sortBy;
        const sortType        = this.state.sortType;
        filteredList        = sortType === 'asc' ? _.sortBy(filteredList, sortBy) : _.sortBy(filteredList, sortBy).reverse();

        const lspId = user.LspId;

        let headerArr = [];
        if (this.state.type === 'product')
            headerArr = ['Date', 'Receipt No', 'Serial No', 'Description', 'Product SKU', 'Lot No', 'RX No', 'Instructions', 'Status', 'Weight (g)', 'Return By', 'Reason', 'Prescription', 'BioTrackDt', 'BioTrackResponse', 'Owner', 'Location', 'Sold By'];
        else
            headerArr = ['Date', 'Receipt No', 'Total Items', 'Total Cost', 'Discount', 'Tax', 'Tip', 'Total Invoice', 'Loyalty Used', 'Loyalty Earned', 'Payment Type', 'Status', 'Register', 'Sold By', 'Location', 'BioTrack Start', 'BioTrack Used', 'BioTrack End', 'Educational Materials'];

        return ([
            <div className={'view-history '+this.props.className}>
                <div className='view-history__nav'>
                    <div
                        className={'btn-green view-history__nav--product '+(this.state.type === 'product' ? '' : 'btn-green__disabled')}
                        onClick={() => { 
                            if(!this.state.loading && this.state.type !== 'product') {
                                this.setState({ type : 'product' }, () => { this.loadProductHistory(); }); 
                            }}}>
                        Product History
                    </div>
                    <div
                        className={'btn-green view-history__nav--export '+(this.state.type === 'product' ? '' : 'btn-green__disabled')}
                        onClick={(e) => this.exportHistory(e, 'product')}>
                        <i className="fa fa-cloud-download" aria-hidden="true"></i>
                    </div>
                    <div
                        className={'btn-green '+(this.state.type === 'transaction' ? '' : 'btn-green__disabled')}
                        onClick={() => { 
                            if(!this.state.loading && this.state.type !== 'transaction') {
                                this.setState({ type : 'transaction' }, () => { this.loadTransactionHistory(); }); }
                        }}>
                        Transaction History
                    </div>
                    <div
                        className={'btn-green  view-history__nav--export '+(this.state.type === 'transaction' ? '' : 'btn-green__disabled')}
                        onClick={(e) => this.exportHistory(e, 'transaction')}>
                        <i className="fas fa-cloud-download-alt" aria-hidden="true"></i>
                    </div>

                    <input
                        type='text'
                        className='view-history__nav--filter'
                        placeholder='Filter'
                        value={this.state.filter}
                        onChange={(e) => { this.setState({ filter : e.target.value }, () => { $('#table').trigger('updateContent'); }); }} />
                </div>

                <div className='view-history__gradient' />
                { this.state.loading &&
                    <div>Loading...</div>
                }
                { !this.state.loading && this.state.type === 'product' &&
                    <div className='view-history__container' id='view-history__container'>
                        <StickyHeader
                            headerArr={headerArr}
                            table='table'
                            container='view-history__container' />

                        <table className='table-1' id='table'>
                            <thead>
                                <tr id='headerRow'>
                                    <th onClick={() => { this.setState({ sortBy : 'PosDate', sortType : this.state.sortType === 'asc' ? 'desc' : 'asc' }); }}>Date</th>
                                    <th onClick={() => { this.setState({ sortBy : 'ReceiptNo', sortType : this.state.sortType === 'asc' ? 'desc' : 'asc' }); }}>Receipt No</th>
                                    <th onClick={() => { this.setState({ sortBy : 'SerialNo', sortType : this.state.sortType === 'asc' ? 'desc' : 'asc' }); }}>Serial No</th>
                                    <th onClick={() => { this.setState({ sortBy : 'ProductDesc', sortType : this.state.sortType === 'asc' ? 'desc' : 'asc' }); }}>Description</th>
                                    <th>Product SKU</th>
                                    <th>Lot No</th>
                                    <th>RX No</th>
                                    { lspId !== 1067 && <th>Instructions</th> }
                                    <th>Status</th>
                                    <th>Weight (g)</th>
                                    <th>Return By</th>
                                    <th>Reason</th>
                                    { lspId !== 1067 && [
                                        <th>Prescription</th>,
                                        <th>Integration Sync Date</th>,
                                        <th>Integration Response</th>
                                    ]}
                                    <th>Owner</th>
                                    <th>Location</th>
                                    <th>Sold By</th>
                                </tr>
                            </thead>
                            <tbody>
                                { filteredList && filteredList.map((item, i) => {
                                    bgColor = bgColor === '#ffffff' ? '#ebebeb' : '#ffffff';

                                    return (
                                        <tr
                                            style={{ 'backgroundColor' : bgColor }}
                                            key={item.uuid}
                                            id={item.uuid}>

                                            <td>{moment(item.PosDate).format('D MMM Y - hh:mm:ss A')}</td>
                                            <td className='txt-right'>{item.ReceiptNo}</td>
                                            <td className='txt-right'>{item.SerialNo}</td>
                                            <td>{item.ProductDesc}</td>
                                            <td className='txt-right'>{item.ProductSku}</td>
                                            <td>{item.LotNo}</td>
                                            <td>{item.PrescriptionNumber}</td>
                                            { lspId !== 1067 && <td>{item.Instructions}</td> }
                                            <td>{item.PosStatus}</td>
                                            <td className='txt-right'>{item.Equivalent}</td>
                                            <td>{item.ReturnBy}</td>
                                            <td>{item.ReturnReason}</td>
                                            { lspId !== 1067 && [
                                                <td>{item.Prescription}</td>,
                                                <td>{moment(item.BioTrackDt).isValid() ? moment(item.BioTrackDt).format('MM/DD/YYYY hh:mm:ss A') : ''}</td>,
                                                <td>{item.BioTrackResponse}</td>
                                            ]}
                                            <td>{item.OwnerName}</td>
                                            <td>{item.OwnerLocation}</td>
                                            <td>{item.SoldBy}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                }

                { !this.state.loading && this.state.type === 'transaction' &&
                    <div className='view-history__container' id='view-history__container'>
                        <StickyHeader
                            headerArr={headerArr}
                            table='table'
                            container='view-history__container' />

                        <table className='table-1' id='table'>
                            <thead>
                                <tr>
                                    <th onClick={() => { this.setState({ sortType : this.state.sortType === 'asc' ? 'desc' : 'asc' }); }}>Date</th>
                                    <th onClick={() => { this.setState({ sortType : this.state.PosId === 'asc' ? 'desc' : 'asc' }); }}>Receipt No</th>
                                    <th>Total Items</th>
                                    <th>Total Cost</th>
                                    <th>Discount</th>
                                    <th>Revenue Fees/Donations</th>
                                    <th>Non-Revenue Fees/Donations</th>
                                    <th>Tax</th>
                                    {location.UseJory && <th>Tip</th>}
                                    <th>Total Invoice</th>
                                    <th>Loyalty Used</th>
                                    <th>Loyalty Earned</th>
                                    <th>Payment Type</th>
                                    <th>Customer Type</th>
                                    <th>Status</th>
                                    <th>Register</th>
                                    <th>Sold By</th>
                                    <th>Location</th>
                                    <th>BioTrack Start</th>
                                    <th>BioTrack Used</th>
                                    <th>BioTrack End</th>
                                    {(location.EducationalMaterialsAcceptReject || location.EducationalMaterialsAcceptOnly) && <th>Educational Materials</th>}
                                </tr>
                            </thead>
                            <tbody>
                                { filteredList && filteredList.map((item, i) => {

                                    return (
                                        <tr
                                            key={item.uuid}
                                            id={item.uuid}
                                            onClick={() => { this.props.viewTransactionDetails(item); }}>

                                            <td>{moment(item.PosDate).format('D MMM Y - hh:mm:ss A')}</td>
                                            <td className='txt-right'>{item.PosId}</td>
                                            <td className='txt-right'>{item.PosTotalItems}</td>
                                            <td className='txt-right'><Price price={item.PosProductCost} /></td>
                                            <td className='txt-right'><Price price={Math.abs(item.DiscountAmt)} /></td>
                                            <td className='txt-right'><Price price={Math.abs(item.RevenueCashValue)} /></td>
                                            <td className='txt-right'><Price price={Math.abs(item.NonRevenueCashValue)} /></td>
                                            <td className='txt-right'><Price price={item.PosTax} /></td>
                                            {location.UseJory && <td className='txt-right'><Price price={item.TipAmount} /></td>}
                                            <td className='txt-right'><Price price={item.TotalInvoice} /></td>
                                            <td className='txt-right'>{parseFloat(item.LoyaltyUsed).toFixed(2)}</td>
                                            <td className='txt-right'>{parseFloat(item.LoyaltyEarned).toFixed(2)}</td>
                                            <td>{item.PosPaymentType}</td>
                                            <td>{item.CustomerType}</td>
                                            <td>{item.PosStatus}</td>
                                            <td>{item.Register}</td>
                                            <td>{item.TransactionBy}</td>
                                            <td>{item.Location}</td>
                                            <td className='txt-right'>{parseFloat(item.BiotStartAvail).toFixed(2)}</td>
                                            <td className='txt-right'>{parseFloat(item.BiotUsed).toFixed(2)}</td>
                                            <td className='txt-right'>{parseFloat(item.BiotEndAvail).toFixed(2)}</td>
                                            {(location.EducationalMaterialsAcceptReject || location.EducationalMaterialsAcceptOnly) && <td>{_.isNil(item.EducationalMaterialsAccepted) ? null : (item.EducationalMaterialsAccepted ? 'Accepted' : 'Rejected')}</td>}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                }
                <form className="hidden" id="transaction-history-export"
                        action={`${getApiUrl().api +  EndPoints.EXPORT_TRANSACTION_HISTORY}`}
                        method="POST"
                        >
                        <input name="SessionId" type="hidden" value={user.SessionId} />
                        <input name="Guest_id" type="hidden" value={guest.Guest_id} />
                        <input name="LspId" type="hidden" value={user.LspId} />
                        <input name="LocId" type="hidden" value={user.LocId} />
                </form>
                <form className="hidden" id="product-history-export"
                        action={`${getApiUrl().api +  EndPoints.EXPORT_PRODUCT_HISTORY}`}
                        method="POST"
                        >
                        <input name="SessionId" type="hidden" value={user.SessionId} />
                        <input name="Guest_id" type="hidden" value={guest.Guest_id} />
                        <input name="LspId" type="hidden" value={user.LspId} />
                        <input name="LocId" type="hidden" value={user.LocId} />
                </form>


            </div>
        ]);
    }
}

export default ViewHistory;


// self.setState({ selected : item });



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewHistory.react.jsx